import { selectApiData } from 'util/selector/apiSelector';

import { WithData } from 'api/interfaces';
import { AxiosInstance } from 'axios';

import {
  ContactListDto,
  ContactListModel,
  ContactListSendModel,
  mapContactListDtoToModel,
  mapContactListSendModelToDto,
} from './dto/ContactList.dto';

export class ContactListApi {
  constructor(private client: AxiosInstance) {}

  fetch(id: string): Promise<ContactListModel> {
    return this.client
      .get<WithData<ContactListDto>>(`/api/v1/distribution/${id}/contact-list`)
      .then(selectApiData)
      .then(mapContactListDtoToModel);
  }

  async create(id: string, sendModel: ContactListSendModel) {
    const entry = mapContactListSendModelToDto(sendModel);
    return this.client.post(`/api/v1/distribution/${id}/contact-list`, entry);
  }
}
